import { GatsbyLinkProps } from "gatsby";
import { AnchorHTMLAttributes, ReactNode, forwardRef } from "react";

import { Link, MsLink } from "@theme/components";

import * as linkVariants from "../../themes/ms5/variants/links";

interface NavLinkProps
  extends AnchorHTMLAttributes<HTMLAnchorElement>,
    GatsbyLinkProps<HTMLLinkElement> {
  to: string;
  variant?: keyof typeof linkVariants;
  children: ReactNode;
}

/**
 * Nav Link
 *
 * This component helps with checking our links to see if they are internal
 *
 * or external. it then passes the rest of the props down with it
 *
 */
export const NavLink = forwardRef<HTMLAnchorElement, NavLinkProps>(function NavLink(
  { to, children, ...rest },
  ref,
) {
  // check if "to" starts with a / and does not follow with a "blogs"
  const internal = /^\/(?!\/|blogs\/)/.test(to);

  if (!internal) {
    return (
      // Not sure why this is reporting an error when the types look correct and work
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      <Link ref={ref} href={to} {...rest}>
        {children}
      </Link>
    );
  }

  return (
    // Not sure why this is reporting an error when the types look correct and work
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    <MsLink ref={ref} to={to} {...rest}>
      {children}
    </MsLink>
  );
});
